import { getSvgPointFromClient, removeSvgLikeElements } from './tooltips'

export function renderStandardInteractionEvent({
  event,
  eventsGroup,
  svg,
  Snap,
  graph,
  mySvg,
  documentRef,
  playerColour,
  calculateBorderLength,
  registerSelectableEventElement,
}) {
  const iconSize = 30
  const offset = iconSize / 2
  const playerIndex = event.interactorID
  const currentTimestamp = event.timestamp
  const currentPlayer = `Player${playerIndex}`
  const eventDetails = event.eventDetails
  const eventX = graph.getCharacterX(currentPlayer, currentTimestamp)
  const eventY = graph.getCharacterY(currentPlayer, currentTimestamp)

  Snap.load(
    `../../src/image/Interaction_Events/${event.eventType}.svg`,
    function(fragment) {
      fragment.selectAll('*').forEach(function(element) {
        element.attr({ fill: null })
      })
      fragment
        .selectAll('path, rect, circle, ellipse, polygon, polyline')
        .forEach(function(element) {
          element.attr({
            fill: playerColour[currentPlayer] || '#000',
            'fill-opacity': 0.7,
            stoke: '#000',
            'stroke-opacity': 1.0,
          })
        })

      const group = eventsGroup.group()
      group.append(fragment)
      group.transform('')
      group.attr({
        transform: `translate(${eventX - offset},${eventY - offset})`,
        class: 'event-icon-group',
      })
      registerSelectableEventElement(group, event, {
        x: eventX,
        y: eventY,
        radius: 24,
      })
      group.selectAll('svg').forEach(function(svgElement) {
        svgElement.attr({ width: iconSize, height: iconSize })
      })

      let tooltipElements = []
      group.hover(
        mouseEvent => {
          const point = getSvgPointFromClient(
            mySvg,
            mouseEvent.clientX,
            mouseEvent.clientY
          )
          let tipX = point.x + 20
          let tipY = point.y + 20
          if (tipY >= 950) tipY -= 70
          if (tipX >= 5700) tipX -= 220

          const tooltipWidth = Math.min(
            Math.max(250, calculateBorderLength(eventDetails, 50)),
            600
          )
          const border = svg.rect(tipX, tipY, tooltipWidth, 180, 10, 10).attr({
            stroke: 'black',
            fill: 'rgba(255,255,255, 0.9)',
            strokeWidth: '3px',
          })
          const interacteeText = svg.text(130 + tipX, 25 + tipY, 'Interactee: ')
          const interactorText = svg.text(35 + tipX, 25 + tipY, 'Interactor: ')
          const interacteeIcon = svg.image(
            `../../src/image/Characters/${event.interactee}.png`,
            133 + tipX,
            41 + tipY,
            40,
            40
          )
          const interactorIcon = svg.image(
            `../../src/image/Characters/${event.interactor}.png`,
            38 + tipX,
            40 + tipY,
            40,
            40
          )
          const interactorBorder = svg.rect(38 + tipX, 40 + tipY, 40, 40).attr({
            fill: 'none',
            stroke: playerColour[currentPlayer] || '#000',
            'stroke-width': '3',
            opacity: 0.7,
          })
          const interacteePlayer = `Player${event.interacteeID}`
          const interacteeBorder = svg
            .rect(133 + tipX, 41 + tipY, 40, 40)
            .attr({
              fill: 'none',
              stroke: playerColour[interacteePlayer] || '#000',
              'stroke-width': '3',
              opacity: 0.7,
            })
          const interacteeNameElement = svg.text(
            130 + tipX,
            35 + 50 + 20 + tipY,
            event.interactee
          )
          const interactorNameElement = svg.text(
            35 + tipX,
            35 + 50 + 20 + tipY,
            event.interactor
          )

          const foreign = documentRef.createElementNS(
            'http://www.w3.org/2000/svg',
            'foreignObject'
          )
          foreign.setAttribute('x', 35 + tipX)
          foreign.setAttribute('y', 35 + 50 + 20 + tipY + 45)
          foreign.setAttribute('width', 530)
          foreign.setAttribute('height', 60)
          const div = documentRef.createElement('div')
          div.style.maxWidth = '530px'
          div.style.wordBreak = 'break-word'
          div.style.whiteSpace = 'pre-wrap'
          div.style.fontSize = '18px'
          div.style.fontFamily = 'inherit'
          div.style.color = '#222'
          div.textContent = eventDetails
          foreign.appendChild(div)
          mySvg.appendChild(foreign)

          tooltipElements = [
            border,
            interacteeText,
            interacteeIcon,
            interactorText,
            interactorIcon,
            interactorBorder,
            interacteeBorder,
            interacteeNameElement,
            interactorNameElement,
            foreign,
          ]
        },
        () => {
          removeSvgLikeElements(tooltipElements)
          tooltipElements = []
        }
      )
    }
  )
}
